/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	type ApplicationLicenseState,
	type ApplicationLicenseStates,
	LICENSE_STATE_ACTIVE,
	LICENSE_STATE_EXPIRED,
	LICENSE_STATE_SUSPENDED,
	LICENSE_STATE_UNLICENSED,
	populateApplicationLicenseStates,
} from '@jira/platform__license-state/src/license-state.tsx';

type MetaGetter = (name: string) => string | null;

type TenantContextLicenseStates = {
	[applicationName: string]: string;
};

const parseTenantContextLicenseState = (tenantContextValue?: string): ApplicationLicenseState => {
	switch (tenantContextValue) {
		case 'ACTIVE':
			return LICENSE_STATE_ACTIVE;
		case 'SUSPENDED':
			return LICENSE_STATE_SUSPENDED;
		case 'EXPIRED':
			return LICENSE_STATE_EXPIRED;
		default:
			return LICENSE_STATE_UNLICENSED;
	}
};

const parseTenantContextLicenseStates = (
	tenantContextLicenseStates: TenantContextLicenseStates,
): ApplicationLicenseStates =>
	populateApplicationLicenseStates({
		core: parseTenantContextLicenseState(tenantContextLicenseStates['jira-core']),
		software: parseTenantContextLicenseState(tenantContextLicenseStates['jira-software']),
		serviceDesk: parseTenantContextLicenseState(tenantContextLicenseStates['jira-servicedesk']),
		customerService: parseTenantContextLicenseState(
			tenantContextLicenseStates['jira-customer-service'],
		),
		productDiscovery: parseTenantContextLicenseState(
			tenantContextLicenseStates['jira-product-discovery'],
		),
	});

const determineApplicationLicenseStates = (getMetaImpl: MetaGetter): ApplicationLicenseStates => {
	try {
		const tenantContextLicenseStates = JSON.parse(
			getMetaImpl('ajs-product-license-states') || '{}',
		);
		return parseTenantContextLicenseStates(tenantContextLicenseStates);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		// eslint-disable-next-line no-console
		console.warn(`Error parsing application license states from tenant context: ${error}`);
		return populateApplicationLicenseStates();
	}
};

export default determineApplicationLicenseStates;
